import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef, useState } from 'react';

import HideIcon from '../icons/HideIcon';
import ShowIcon from '../icons/ShowIcon';

import { Box } from '../box/box';
import { Button } from '../button/button';
import type { InputFieldProps } from '../input-field/input-field';
import { InputField } from '../input-field/input-field';

export const TEST_IDS = {
  SHOW_HIDE_TOGGLE: 'password-show-hide-toggle',
  SHOW_HIDE_TOGGLE_WRAPPER: 'password-show-hide-toggle-wrapper',
  INPUT: 'password-input',
};

export interface PasswordInputProps
  extends Omit<InputFieldProps, 'type' | 'extraContainerStyles'> {
  showPasswordText: ReactNode;
  hidePasswordText: ReactNode;
}

export const PasswordInput = forwardRef(function PasswordInput(
  { showPasswordText, hidePasswordText, ...inputProps }: PasswordInputProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <InputField
      {...inputProps}
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      data-testid={TEST_IDS.INPUT}
    >
      <Box
        alignContent={{ x: 'center', y: 'center' }}
        padding={{ right: 'baseNeg4' }}
      >
        <Button
          aria-pressed={showPassword}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            setShowPassword(!showPassword);
          }}
          data-testid={TEST_IDS.SHOW_HIDE_TOGGLE}
          variant="icon"
          Icon={showPassword ? HideIcon : ShowIcon}
          iconColor="neutral350"
        >
          {showPassword ? hidePasswordText : showPasswordText}
        </Button>
      </Box>
    </InputField>
  );
});
